import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  NgZone,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MapsAPILoader, MouseEvent } from "@agm/core";
import { Location } from "@angular/common";
import { NgxSpinnerService } from "ngx-spinner";
import { UtilService } from "src/app/services/utils.service";
import { FarmService } from "src/app/services/farm-service.service";
import { Router } from "@angular/router";
import { PhameeService } from "src/app/services/phamee.service";

declare const $: any;
@Component({
  selector: "smart-manage-farm-create",
  templateUrl: "./manage-farm-create.component.html",
  styleUrls: [
    "./manage-farm-create.component.scss",
    "../../platform-color/platform-color.css",
  ],
})
export class ManageFarmCreateComponent implements OnInit {
  form: FormGroup;

  markers: marker[] = [];
  zoom: number = 18;

  // initial center position for the map
  lat: number = 13.764913;
  lng: number = 100.538283;
  loadMap: boolean = false;
  loadSearchBar: boolean = false;
  submitted: boolean = false;

  successModal: string = "#successModal";
  errorModal: string = "#errorModal";
  farm_id: string;
  farm_name: string;

  errorMessage: string = "กรุณาลองใหม่อีกครั้ง";

  provinces = [];
  districts = [];
  subdistricts = [];

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private FarmService: FarmService,
    private PhameeService: PhameeService,
    private UtilService: UtilService,
    private spinner: NgxSpinnerService,
    private location: Location,
    private cd: ChangeDetectorRef,

    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone
  ) {}

  async ngOnInit() {
    this.spinner.show();
    this.createForm();

    this.UtilService.getProvinces().subscribe((res) => {
      this.provinces =
        res.data.sort((a, b) => (a.name_th > b.name_th ? 1 : -1)) || [];
    });

    this.mapsAPILoader.load().then(() => {
      this.setCurrentLocation();
    });

    this.valueChange();
  }

  async setCurrentLocation() {
    console.log(navigator.geolocation);

    if (!navigator.geolocation) {
      console.log("position: broswer not support");

      this.form.get("lat").setValue(this.lat);
      this.form.get("lon").setValue(this.lng);

      this.markers.push({
        lat: this.lat,
        lng: this.lng,
        draggable: true,
        icon: "assets/img/marker.png",
      });

      this.loadMap = true;
      this.spinner.hide();

      this.reset();
    } else {
      let current = await this.getCurrentLocation({
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      });
      if (current) {
        console.log("position:", current);

        this.lat = parseFloat(current["coords"].latitude.toFixed(6));
        this.lng = parseFloat(current["coords"].longitude.toFixed(6));

        this.form.get("lat").setValue(this.lat);
        this.form.get("lon").setValue(this.lng);

        this.markers.push({
          lat: this.lat,
          lng: this.lng,
          draggable: true,
          icon: "assets/img/marker.png",
        });

        this.loadMap = true;
        this.spinner.hide();

        this.reset();
      }
    }
  }

  getCurrentLocation(options) {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        resolve,
        ({ code, message }) =>
          reject(
            Object.assign(new Error(message), { name: "PositionError", code })
          ),
        options
      );
    });
  }

  reset() {
    this.cd.detectChanges();
  }

  valueChange() {
    this.form.controls.province_id.valueChanges.subscribe((value) => {
      if (value != this.form.value["province_id"]) {
        let findProvince = this.provinces.find(
          (province) => province.id == value
        );
        if (findProvince) {
          this.form.get("province_code").setValue(findProvince.code);
          this.form.get("province_name_th").setValue(findProvince.name_th);
        }

        this.form.get("district_id").setValue("");
        this.form.get("district_code").setValue("");
        this.form.get("district_name_th").setValue("");

        this.form.get("subdistrict_id").setValue("");
        this.form.get("subdistrict_code").setValue("");
        this.form.get("subdistrict_name_th").setValue("");

        this.UtilService.getDistricts(value).subscribe((res) => {
          this.districts =
            res.data.sort((a, b) => (a.name_th > b.name_th ? 1 : -1)) || [];
        });
      }
    });

    this.form.controls.district_id.valueChanges.subscribe((value) => {
      if (value != this.form.value["district_id"]) {
        let findDistrict = this.districts.find(
          (district) => district.id == value
        );
        if (findDistrict) {
          this.form.get("district_code").setValue(findDistrict.code);
          this.form.get("district_name_th").setValue(findDistrict.name_th);
        }

        this.form.get("subdistrict_id").setValue("");
        this.form.get("subdistrict_code").setValue("");
        this.form.get("subdistrict_name_th").setValue("");

        this.UtilService.getSubDistricts(value).subscribe((res) => {
          this.subdistricts =
            res.data.sort((a, b) => (a.name_th > b.name_th ? 1 : -1)) || [];
        });
      }
    });

    this.form.controls.subdistrict_id.valueChanges.subscribe((value) => {
      if (value != this.form.value["subdistrict_id"]) {
        let findSubdistrict = this.subdistricts.find(
          (subdistrict) => subdistrict.id == value
        );
        if (findSubdistrict) {
          this.form.get("subdistrict_code").setValue(findSubdistrict.code);
          this.form
            .get("subdistrict_name_th")
            .setValue(findSubdistrict.name_th);
        }
      }
    });
  }

  coordinateChanged() {
    let { lat, lon } = this.form.getRawValue();

    this.markers = [];
    this.markers.push({
      lat: parseFloat(lat),
      lng: parseFloat(lon),
      draggable: true,
      icon: "assets/img/marker.png",
      
    });

    this.lat = parseFloat(lat);
    this.lng = parseFloat(lon);
    this.reset();
  }

  createForm() {
    this.form = this.formBuilder.group({
      name: ["", [Validators.required, Validators.pattern(/[\S]/g)]],
      desc: [""],
      addr1: [""],
      lat: ["", [Validators.required]],
      lon: ["", [Validators.required]],
      zoom_lv: [18],
      subdistrict_id: ["", [Validators.required]],
      subdistrict_code: [""],
      subdistrict_name_th: [""],
      district_id: ["", [Validators.required]],
      district_code: [""],
      district_name_th: [""],
      province_id: ["", [Validators.required]],
      province_code: [""],
      province_name_th: [""],
    });
  }

  mapClicked($event: MouseEvent) {
    console.log("DDDDQQWQWQW");
    this.markers = [];
    this.markers.push({
      lat: $event.coords.lat,
      lng: $event.coords.lng,
      draggable: true,
      icon: "assets/img/marker.png",
    });

    this.form.get("lat").setValue(parseFloat($event.coords.lat.toFixed(6)));
    this.form.get("lon").setValue(parseFloat($event.coords.lng.toFixed(6)));
  }

  clickedMarker(label: string, index: number) {
    console.log(`clicked the marker: ${label || index}`);
  }

  markerDragEnd(m: marker, $event: MouseEvent) {
    console.log("dragEnd", m, $event);

    this.form.get("lat").setValue(parseFloat($event.coords.lat.toFixed(6)));
    this.form.get("lon").setValue(parseFloat($event.coords.lng.toFixed(6)));
  }

  mapReady(map) {
    map.setOptions({
      zoomControl: "true",
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM,
      },
      draggable: true,
    });

    const search = document.getElementById("search") as HTMLElement;

    map.controls[google.maps.ControlPosition.TOP_LEFT].push(search);

    const input = document.getElementById("search-input") as HTMLInputElement;

    const defaultBounds = {
      north: this.lat + 0.1,
      south: this.lat - 0.1,
      east: this.lng + 0.1,
      west: this.lng - 0.1,
    };

    const options = {
      bounds: defaultBounds,
      componentRestrictions: { country: "th" },
      fields: ["address_components", "geometry", "icon", "name"],
      strictBounds: false,
      types: ["establishment"],
    };

    const autocomplete = new google.maps.places.Autocomplete(input, options);

    // Set initial restriction to the greater list of countries.
    autocomplete.setComponentRestrictions({
      country: ["th"],
    });

    autocomplete.addListener("place_changed", () => {
      this.ngZone.run(() => {
        //get the place result
        let place: google.maps.places.PlaceResult = autocomplete.getPlace();

        //verify result
        if (place.geometry === undefined || place.geometry === null) {
          return;
        }

        //set latitude, longitude and zoom
        this.lat = place.geometry.location.lat();
        this.lng = place.geometry.location.lng();
        this.zoom = 18;

        this.reset();
      });
    });

    setTimeout(() => {
      this.loadSearchBar = true;
      this.reset();
    }, 1000);
  }

  zoomChange(zoom_lv) {
    this.form.get("zoom_lv").setValue(zoom_lv);
  }

  get f() {
    return this.form.controls;
  }

  save() {
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }

    let form = this.form.value;
    let data = {
      org_id: sessionStorage.getItem("Org"),
      child_org_id: sessionStorage.getItem("ChildOrg"),
      name: form.name,
      active: true,
      desc: form.desc,
      addr1: form.addr1,
      addr2: null,
      subdistrict: {
        code: form.subdistrict_code,
        name_th: form.subdistrict_name_th,
      },
      district: {
        code: form.district_code,
        name_th: form.district_name_th,
      },
      province: {
        code: form.province_code,
        name_th: form.province_name_th,
      },
      coordinates: {
        center: {
          lat: form.lat,
          lon: form.lon,
          zoom_lv: form.zoom_lv,
        },
      },
    };
    this.FarmService.createFarm(data).subscribe((res) => {
      if (res.code == 200) {
        this.farm_id = res.data.farm_id;
        this.farm_name = res.data.name;

        $(`${this.successModal}`).modal("show");
      } else {
        if (res.message == "Data existed") {
          this.errorMessage = "ชื่อฟาร์มของท่านมีอยู่แล้ว กรุณาลองใหม่อีกครั้ง";

          this.reset();
          $(`${this.errorModal}`).modal("show");
        } else {
          this.errorMessage = "กรุณาลองใหม่อีกครั้ง";

          this.reset();
          $(`${this.errorModal}`).modal("show");
        }
      }
    });
  }

  async addPlot() {
    await this.PhameeService.getPlotMenu(
      sessionStorage.getItem("ChildOrg")
    ).subscribe((response) => {
      let arrMenu = [];
      if (response.code == 200) {
        arrMenu = response.data;
        sessionStorage.setItem("menufarm", JSON.stringify(arrMenu));

        this.router
          .navigateByUrl(
            `/manage-farm/${this.farm_id}/${this.farm_name}/plot/createPlot`
          )
          .then(() => {
            window.location.reload();
          });
      }
    });
  }

  async back(refresh = false) {
    if (refresh) {
      await this.PhameeService.getPlotMenu(
        sessionStorage.getItem("ChildOrg")
      ).subscribe((response) => {
        let arrMenu = [];
        if (response.code == 200) {
          arrMenu = response.data;
          sessionStorage.setItem("menufarm", JSON.stringify(arrMenu));
          this.router.navigate(["/manage-farm"]).then(() => {
            window.location.reload();
          });
        }
      });
    } else {
      this.router.navigateByUrl("/manage-farm");
    }
  }

  openGooglemap() {
    let url =
      "https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=" +
      this.form.value.lat +
      "," +
      this.form.value.lon;
    window.open(url, "_blank");
  }
}

interface marker {
  lat: number;
  lng: number;
  label?: string;
  draggable: boolean;
  icon?: string;
}
